export const telephoneNumbers = {
  customerServices: '03330 30 82 97',
  newSales: '03330 30 83 72',
  businessDevelopmentManager: '03330 30 83 89',
  newPolicies: '03330 30 82 74',
  renewals: '03330 30 82 48',
  claims: '03330 30 83 70',
  claimSupport: '03330 30 83 70',
  vetSupport: '03330 30 83 90',
  rehomingSupport: '03330 30 83 89',
  breederSupport: '03330 30 83 75',
  illnessInjurySupport: '03330 30 82 97',
} as const;
